import { Button, HStack, Text } from '@chakra-ui/react'

import { useSchedulerContext } from '..'
import { createColorFromPrimaryText } from '../utils/colors'

export const TimeslotsHeader = () => {
	const { styles, timeFormat, setTimeFormat } = useSchedulerContext()

	const baseColor = createColorFromPrimaryText(styles.text_primary)

	return (
		<HStack w="full" justifyContent="space-between">
			<Text fontSize="14px" fontWeight={400} color={baseColor.fade(0.3).hexa()}>
				Select a time
			</Text>
			<HStack gap="0px">
				<TimeFormatButton
					isSelected={timeFormat === '12hr'}
					onClick={() => setTimeFormat('12hr')}
				>
					12hr
				</TimeFormatButton>
				<TimeFormatButton
					isSelected={timeFormat === '24hr'}
					onClick={() => setTimeFormat('24hr')}
				>
					24hr
				</TimeFormatButton>
			</HStack>
		</HStack>
	)
}

const TimeFormatButton = ({
	children,
	isSelected,
	onClick,
}: {
	children: React.ReactNode
	isSelected?: boolean
	onClick: () => void
}) => {
	const { styles } = useSchedulerContext()
	return (
		<Button
			fontSize="13px"
			color={styles.text_primary}
			fontWeight={400}
			bg={isSelected ? styles.bg_secondary : 'transparent'}
			border="1px solid"
			borderColor={isSelected ? styles.border_primary : 'transparent'}
			borderRadius="8px"
			px="10px"
			py="6px"
			h="fit-content"
			w="fit-content"
			_hover={{
				bg: isSelected ? styles.bg_secondary : 'transparent',
				borderColor: isSelected ? styles.border_primary : 'transparent',
			}}
			onClick={onClick}
		>
			{children}
		</Button>
	)
}
